import { call, put, all, takeLatest } from "redux-saga/effects";

import { getRangeTimeKeepingAPI } from "core/http/service/timeKeeping";
import {
  getRangeTimeKeepingFailed,
  getRangeTimeKeepingStart,
  getRangeTimeKeepingSuccess,
} from "../redux/getRangeTimeKeeping";
import { toast } from "react-toastify";

function* getRangeTimeKeepingWork(action) {
  const data = action.payload;

  try {
    const res = yield call(getRangeTimeKeepingAPI, data);
    if (res) {
      yield put({
        type: getRangeTimeKeepingSuccess.type,
        payload: res,
      });
      //   toast.success("Cập nhật đơn thành công!");
    }
  } catch (err: any) {
    yield put({
      type: getRangeTimeKeepingFailed.type,
    });
    toast.error(err?.response?.data?.message || "Đã có lỗi xảy ra!");
  }
}

function* watchGetRangeTimeKeeping() {
  yield takeLatest(getRangeTimeKeepingStart.type, getRangeTimeKeepingWork);
}

export default function* getRangeTimeKeepingSaga() {
  yield all([watchGetRangeTimeKeeping()]);
}
